// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609090419/js/" + chunkId + "." + {"44":"5b3774e4","225":"ba2dd398","481":"c9f38dc4","486":"02bdd281","770":"980d969b"}[chunkId] + ".0.2698790394845172.chunk.js";
};